import { Component, OnInit, ElementRef, ViewChild, AfterViewChecked, HostListener, ChangeDetectorRef, ChangeDetectionStrategy, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ChatbotBasicQuestionAns } from 'app/models/chatbotBasicQuestionAns/ChatbotBasicQuestionAns';
import { ChatMasterQuestionAns } from 'app/models/chatMasterQuestionAns/ChatMasterQuestionAns';
import { ChatUniqueQuery } from 'app/models/chatUniqueQuery/ChatUniqueQuery';
//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import * as CryptoJS from 'crypto-js';
import { quickPayModel } from 'app/models/quickpay/quickpay.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ChatbotComponent implements OnInit {

  public messageArray: any = [];
  questionArray: any[] = [];
  answerArray: any[] = [];
  dataArray: any[] = [];
  ConsumerIDList: any[] = [];
  bufferArray: any[] = [];
  bufferArrayforuserquery: any[] = [];
  mydata: any;
  message: any;
  singledata: any;
  answercounter: any = 0;
  textboxdata: any;
  userinput: any = "";
  userinput2: any;
  branchlocator: any;
  alllocation: any;
  locationid: any;
  dailywish: any;
  IsLink: any;
  consumerID: any;
  consumerPwd: any;
  consumerIDFlag: boolean = false;
  FlagDisbleConsumerCounter: any = 0;
  credentialmodelid: any;
  credentialmodelpwd: any;
  authUser: any;
  errorMsg: any;
  successMsg: any;
  loggedInUserData: any = "";
  SEC_KEY_ID_1: any = '14587jfaeryn%$#7542Hfra45';
  SEC_KEY_ID_2: any = '!@#12458/nhs&^%sunh0098%$#';
  parentId: number = 0;
  responseObj: any = {};
  captchaView: string = "";
  public sessionData: any;
  public generalBroadCast: any = [];
  public regeonalBroadCast: any = [];
  public zonalBroadCast: any = [];
  public today: any = new Date().getTime();
  public disableScrollDown: boolean = false;
  public pastBillFlag: boolean = false;
  public quickPayModel: quickPayModel = new quickPayModel;
  public passwordField: boolean = false;
  public consumerNoAndDate: string = "";
  public getBillDetailsBlocked: boolean = false;
  public spinnerload: boolean = false;
  public billFetched: boolean = false;
  public allBillData: any = "";
  public status : any = "";
  public downloadBillCounter: number = 0;
  public disabledMenu : boolean = false ;
  forgotresponse: any;
  public allGrevienceData: any;

  constructor(public http: HttpTestService,
    public session: sessionServices,
    public route: Router,
    public actvRoute: ActivatedRoute,
    public cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer) { }
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  ngAfterViewChecked() {
    //this.scrollToBottom();
    //this.getSession();
     //this.scrollToUp();
  }
  ngOnInit() {  
    //this.scrollToUp();
    this.getSession();
    this.getBroadcastData();
    this.getFirstButtons();
    this.scrollToBottom();
    //this.cd.detach();
  }
  onScroll() {
    let element = this.myScrollContainer.nativeElement
    let atBottom = (element.scrollHeight - element.scrollTop) //=== element.clientHeight
    if (this.disableScrollDown && atBottom) {
      this.disableScrollDown = false
    } else {
      this.disableScrollDown = true
    }
  }

  scrollToBottom() {
     setTimeout(()=>{
      try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      } catch (err) { }
     },1000);    
  }
  scrollToUp() {
    try {
      this.myScrollContainer.nativeElement.scrollBottom = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  //get session details
  getSession = function () {
    this.serviceOn = true;
    this.sessionData = this.session.getSessionDetails();
    this.serviceOn = false;
  }

  getFirstButtons() {
    this.http.getFirstQuestion().subscribe((success) => {
      this.messageArray = (success.responseList)
      this.cd.detectChanges();
      this.scrollToBottom();
    }, (error) => { });
    this.scrollToBottom();
  }
  //--------------------------------------------//
  ask(UniqueId: any, num: any) {

    this.disabledMenu = true;
    this.spinnerload = true;
    if(this.sessionData.sessionStarted === "false") { // this.sessionData.sessionStarted === "false"
      // Question pushing
      let data2: ChatUniqueQuery = {
        id: UniqueId,
        consumerId: '',
        consumerPwd: ''
      }
      this.http.getUniqueAns(data2).subscribe((res: any) => {
        this.dataArray = [];
        this.dataArray.push(res.responseObj);
        for (let key of this.dataArray) {
          key.newcolumn = "Q"
          this.answerArray.push(key);
        }
        this.scrollToBottom();
      });
      this.spinnerload = false;
      //For Customer Profile
      if (num == 1002 || num == 1003 || num == 1065 || num == 1005 || num == 1006 || num == 1008) {
        //if (this.sessionData.sessionStarted === "false") { }
        this.spinnerload = true;
        this.consumerIDFlag = true;
        this.FlagDisbleConsumerCounter = this.FlagDisbleConsumerCounter + 1;
        this.parentId = num;
        setTimeout(() => {
          var uniquequestion = "Please Enter Your Consumer ID";
          this.pushingAnswer(uniquequestion);
        }, 1000);
        this.scrollToBottom();
        this.spinnerload = false;
        
        //this.disabledMenu = false;

      } // end of if for num == 1002
      else {
        this.spinnerload = true;
        // Answer Pushing
        this.consumerIDFlag = false;
        this.FlagDisbleConsumerCounter = 0;
        setTimeout(() => {
          let data: ChatUniqueQuery = {
            id: num,//root_id
            consumerId: '',
            consumerPwd: ''
          }
          //------call By ParentId-------------------//
          this.http.getAnswer(data).subscribe((res: any) => {
            this.answercounter = 0;
            for (let item in res.responseList) {
              this.answercounter = this.answercounter + 1;
            }
            this.dataArray = [];
            this.dataArray.push(res.responseList);
            //-----for link-------------//
            for (let item of this.dataArray) {
              for (let items of item) {
              
                //---------------Test Link----------------//
                this.textboxdata = items.question
                items.counter = this.answercounter;
                items.newcolumn = "A";
                if (items.QuestionName && items.QuestionName === "/nsc") this.newConnection();
                else if (items.QuestionName && items.QuestionName === "/feedback") this.goToFeedback();
                else if (items.QuestionName && items.QuestionName === "/quickpay") this.goToQuickpay();
                else if (items.QuestionName && items.QuestionName === "/paymentNsc") this.goToPaymentNsc();
                else this.answerArray.push(items);
                this.IsLink = items.link;
                //---------------Test Link---------------//
                
              }
            } 
            this.scrollToBottom();
            this.disabledMenu = false;
            //this.generateCaptcha();

            //----for Button---------------//
            if (this.answercounter == 1 && this.IsLink == "False") {
              this.singledata = res.responseList;
              this.dataArray.push(this.singledata)
              for (let items of this.dataArray) {
                for (let item of items) {
                  var data4 = item.parent_id;
                }
              }
              let data3 = {
                id: data4
              }
              //--------call by Next_id--------------------//
              this.http.getNextQuestion(data3).subscribe((resp: any) => {
                this.answercounter = 0;

                for (let item in resp.responseList) {
                  this.answercounter = this.answercounter + 1;
                }
                this.bufferArray = []
                this.bufferArray.push(resp.responseList)
                for (let item of this.bufferArray) {
                  for (let items of item) {
                    items.counter = this.answercounter;
                    items.newcolumn = "A";
                    this.answerArray.push(items);
                  }
                }
                this.scrollToBottom();
              })
              this.scrollToBottom();
              this.disabledMenu = false;
            }
            else { }
          });
        }, 2000);
        this.spinnerload = false;
      }
    } else if( this.sessionData.sessionStarted === "true" ){ //  this.sessionData.sessionStarted === "true"
        this.disabledMenu= false ;
        // Question pushing
        let data2: ChatUniqueQuery = {
          id: UniqueId,
          consumerId: '',
          consumerPwd: ''
        }
        this.http.getUniqueAns(data2).subscribe((res: any) => {
          this.dataArray = [];
          this.dataArray.push(res.responseObj);
          for (let key of this.dataArray) {
            key.newcolumn = "Q"
            this.answerArray.push(key);
          }
          this.scrollToBottom();
        });
        this.spinnerload = false;
         //For Customer Profile - this.sessionData.sessionStarted === "true"
      if (num == 1002 || num == 1003 || num == 1065 || num == 1005 || num == 1006
        || num == 1008){ //for this.sessionData.sessionStarted === "true"
        this.parentId = num;
        //--------------------------//
        switch (this.parentId) {
          case 1002:
            //this.getLinkforConsumerProfile();
            this.goToConsumerProfile();
            break;
          case 1003:
            this.goToComplaintReporting();
            break;
          case 1005:
            this.viewPastBills(this.parentId);
            break;
          case 1065:
            this.getEmailId();
            break;
          case 1006:
            this.getBillHistory();
            break;
          case 1008:
            this.disableForgotPasswordWhenLoggedIn();
            break;
          default:
            this.pushingAnswer("Please, try again later!");
            this.scrollToBottom();
            break;
        }

        //--------------------------//
      } else { //else of this.sessionData.sessionStarted === "true" 
        this.spinnerload = true;
        setTimeout(() => {
          let data: ChatUniqueQuery = {
            id: num,//root_id
            consumerId: '',
            consumerPwd: ''
          }
          //------call By ParentId-------------------//
          this.http.getAnswer(data).subscribe((res: any) => {
            this.answercounter = 0;
            for (let item in res.responseList) {
              this.answercounter = this.answercounter + 1;
            }
            this.dataArray = [];
            this.dataArray.push(res.responseList);
            //-----for link-------------//
            for (let item of this.dataArray) {
              for (let items of item) {
                /*if(items.Link && items.Link == "True"  && items.IsButton =="False"){
                  this.textboxdata = items.question
                  items.counter = this.answercounter;
                  items.newcolumn = "A";
                  if (items.QuestionName) {
                    switch (items.QuestionName) {
                      case "/nsc": 
                        this.newConnection();
                        break;
                      case "/feedback": 
                        this.goToFeedback();
                        break; 
                      case "/quickpay": 
                        this.goToQuickpay();
                        break;  
                      default : 
                          this.pushingAnswer("Please, try again later!");
                          this.scrollToBottom();
                          break; 
                    }
                  }
                  else this.answerArray.push(items);
                  this.IsLink = items.link;
                }*/
                this.textboxdata = items.question
                items.counter = this.answercounter;
                items.newcolumn = "A";
                if (items.QuestionName && items.QuestionName === "/nsc") this.newConnection();
                else if (items.QuestionName && items.QuestionName === "/feedback") this.goToFeedback();
                else if (items.QuestionName && items.QuestionName === "/quickpay") this.goToQuickpay();
                else if (items.QuestionName && items.QuestionName === "/paymentNsc") this.goToPaymentNsc();
                else this.answerArray.push(items);
                this.IsLink = items.link;
                
              }
            }
            this.scrollToBottom();
            //this.generateCaptcha();

            //----for Button---------------//
            if (this.answercounter == 1 && this.IsLink == 'False') {
              this.singledata = res.responseList;
              this.dataArray.push(this.singledata)
              for (let items of this.dataArray) {
                for (let item of items) {
                  var data4 = item.parent_id;
                }
              }
              let data3 = {
                id: data4
              }
              //--------call by Next_id--------------------//
              this.http.getNextQuestion(data3).subscribe((resp: any) => {
                this.answercounter = 0;

                for (let item in resp.responseList) {
                  this.answercounter = this.answercounter + 1;
                }
                this.bufferArray = []
                this.bufferArray.push(resp.responseList)
                for (let item of this.bufferArray) {
                  for (let items of item) {
                    items.counter = this.answercounter;
                    items.newcolumn = "A";
                    this.answerArray.push(items);
                  }
                }
                this.scrollToBottom();
              })
            }
            else { }
          });
        }, 2000);
        this.spinnerload = false;
      }
    }
    
    this.scrollToBottom();
  }  

  sendtextmsg() {

    if (this.FlagDisbleConsumerCounter == 2) {
      this.pushingQuestion("****");
      this.scrollToBottom();

      this.consumerPwd = this.userinput;
      this.FlagDisbleConsumerCounter = this.FlagDisbleConsumerCounter+1; //TODO
      this.consumerIDFlag = true;
      setTimeout(() => {
        let data: any = {
          consumerId: this.consumerID,
          consumePwd: this.consumerPwd
        }
        this.credentialmodelid = data;
        this.userinput = '';
        this.passwordField = false;
       
        this.generateCaptcha();
        var getnumber = "Please Enter the CAPTCHA:- " +this.captchaView;
        //this.sanitizer.bypassSecurityTrustHtml('<svg>{{captchaView}}</svg>'); console.log("getnumber > ",getnumber);
        // Question pushing
        this.pushingAnswer(getnumber);
      }, 1000);
      this.scrollToBottom();
    } //end of FlagDisbleConsumerCounter == 2 
    else {
      // For Consumer ID
      if (this.consumerIDFlag == true) {
        if (this.FlagDisbleConsumerCounter == 1) {
          this.consumerID = this.userinput;
          // Question pushing
        this.userinput2 = this.userinput; //This is to print ConsumerID in a question
        this.consumerPwd = this.userinput;
        this.userinput = '';
        this.pushingQuestion(this.userinput2);
        this.scrollToBottom();
        if( this.parentId == 1008 ){
          this.disabledMenu = false;
          this.forgotPassword();
          return;
        }

        setTimeout(() => {
          var getnumber = "Please Enter Your Password";
          // Question pushing
          this.pushingAnswer(getnumber);
          this.userinput = '';
          this.FlagDisbleConsumerCounter = this.FlagDisbleConsumerCounter + 1; //TODO
          this.passwordField = true;
        }, 1000);
        this.scrollToBottom();
        
        }
        if (this.FlagDisbleConsumerCounter == 3) {
          this.pushingQuestion(this.userinput);
          this.scrollToBottom();
          if(this.captchaView === this.userinput){ //captcha checking if
            setTimeout(() => {
              this.userinput = '';
              this.FlagDisbleConsumerCounter = 0; //TODO
              this.passwordField = false;
              this.consumerIDFlag = false;
              this.disabledMenu = false;
              this.authenticateUser(); //for login purpose
            }, 1000);
            this.scrollToBottom();
          } else { //captcha checking else
              this.pushingAnswer("Please enter the valid captcha.");
              this.userinput = '';
              this.scrollToBottom();
          }  //end of captcha checking else       
          
        }
      } // end of this.consumerIDFlag==true
      
      else {
        if(this.downloadBillCounter == 1) {
          let userbillinput = this.userinput; 
          this.userinput = '';
          this.pushingQuestion(userbillinput);
          this.scrollToBottom();
          if( this.allBillData[userbillinput-1] === undefined){
            this.pushingAnswer("Incorrect serial number. Please try again.");
            this.scrollToBottom();
          } else {
            this.downloadBillCounter = 0;
            this.getBillDetailsforDownload( this.allBillData[userbillinput-1].split(" ")[1]);
            userbillinput = '';
            setTimeout(() => {
              this.pushingAnswer("To download again press menu button above.");
            }, 1000);
            this.scrollToBottom();
          }
          
        } else {
        // Question pushing for invalid query or type in hand
        this.userinput2 = this.userinput;
        this.userinput = '';
        this.pushingQuestion(this.userinput2); // for invalid query
        
        this.scrollToBottom();

        //  Answer Pushing
        setTimeout(() => {
          let data: ChatbotBasicQuestionAns = {
            chatQuery: this.userinput2,
            id: 0,
            query: '',
            answer: ''
          }
          this.http.getUserQuery(data).subscribe((res: any) => {

            if (res.responseMessage == 'No Data Found.') {
              this.pushingAnswer("Sorry ! Invalid Query");
              this.passwordField = false;
              this.scrollToBottom();
            } else {
              this.bufferArrayforuserquery.push(res.responseObj)
              let result: any;
              this.bufferArrayforuserquery.forEach((item) => { result = item.answer; });
              this.pushingAnswer(result);
              this.scrollToBottom();
            }
          })
          this.scrollToBottom();
        }, 1000);
        this.scrollToBottom(); }
      } // end of else == this.consumerIDFlag==false
      
    }
    this.scrollToBottom();
  }// end of sendtextmsg() function
  
  home() {
    this.answerArray = [];
    this.passwordField = false;
    this.userinput = '';
    this.FlagDisbleConsumerCounter = 0;
    this.consumerIDFlag = false;
    this.disabledMenu = false;
  }

  adminlogin() {
    this.route.navigate(['container/adminlogin'])
  }
  /*getwish() {
    this.apicall.getMethod('Home/Getwish').subscribe((response) => {
      this.dailywish = response;
      console.log(this.dailywish)
    });
  }*/
  //---------This is a generalised function to push question & answer-----//
  pushingAnswer(ansN: any) {
    let ansData: ChatMasterQuestionAns = {
      Id: 1,
      QuestionName: ansN,
      Parent_id: "1",
      Next_id: 1,
      Root_id: 1,
      newcolumn: 'A',
      Isquestion: 1,
      IsButton: "",
      Link: ""
    };
    this.dataArray = [];
    this.dataArray.push(ansData);
    this.dataArray.forEach((element) => { this.answerArray.push(element); });
  }
  pushingQuestion(questionN: any) {
    let ansData: ChatMasterQuestionAns = {
      Id: 1,
      QuestionName: questionN,
      Parent_id: "1",
      Next_id: 1,
      Root_id: 1,
      newcolumn: 'Q',
      Isquestion: 1,
      IsButton: "",
      Link: ""
    };
    this.dataArray = [];
    this.dataArray.push(ansData);
    this.dataArray.forEach((element) => { this.answerArray.push(element); });
  }
  //---------End of This is a generalised function to push question-----//

  //----------This function is used for login purpose-----------//
  authenticateUser() {
    var self = this;
    //self.serviceOn = true;

    var id = this.consumerID;
    var pass = this.consumerPwd;
    let body = new URLSearchParams();
    body.set('consumerId', id);
    body.set('password', pass);
    //let fullurl = id + "^" + pass + '/authenticateByConsumerIdPassword';
    this.http.newAuthenticateUser(body.toString()).subscribe(
      (data) => {
        this.authUser = data;
        this.http.userLoggedIn.emit();
        this.http.getConsumerDetailsfromService(id);
      },
      (error) => {
        this.errorMsg = "Some error occurred!";
        this.authUser = error;
        this.cd.detectChanges();
        //self.serviceOn = false;
      },
      () => {
        if (self.authUser['responseStatus'] === 0) {
          self.errorMsg = "Incorrect password! Plase try again.";
          this.passwordField = false;
          this.pushingAnswer(self.errorMsg);
          this.cd.detectChanges();
          this.scrollToBottom();
          //	self.serviceOn = false;
        } else if (self.authUser['responseStatus'] === 1) {
          this.cd.detectChanges();
          this.pushingAnswer("Thank you");
          this.passwordField = false;
          this.scrollToBottom();

          self.getConsumerDetails(this.consumerID);
        } else if (self.authUser.status === 2) {//GAYA_CONSUMER_NOT_AVAILABLE
          self.errorMsg = "Service is not available for this number range!";
          this.passwordField = false;
          this.pushingAnswer(self.errorMsg);
          this.cd.detectChanges();
          this.scrollToBottom();
          //	self.serviceOn = false;
        }
      }
    );
  }
  //----------------End of  login purpose----------------------//
  getConsumerDetails(requestedId: any) {
    var self = this;
    this.errorMsg = "";
    this.successMsg = "";

    this.http.getConsumerInfoByConsumerId(requestedId).subscribe(
      (data) => {
        this.loggedInUserData = data;
        this.cd.detectChanges();
      },
      (error) => {
        this.errorMsg = error;
        this.loggedInUserData = "";
        this.cd.detectChanges();
        //this.serviceOn = false;
      },
      () => {
        if (this.loggedInUserData.name && this.loggedInUserData.registered) {
          var key = this.SEC_KEY_ID_1;
          var iv = this.SEC_KEY_ID_2;
          var sessionKey = this.SEC_KEY_ID_1 + "true!^@#" + this.SEC_KEY_ID_1 + this.loggedInUserData.name + "!^@#" + this.SEC_KEY_ID_1 + self.loggedInUserData.emailid + "!^@#" + this.SEC_KEY_ID_1 + self.loggedInUserData.region + "!^@#" + this.SEC_KEY_ID_1 + self.loggedInUserData.businessAreaText + "!^@#" + this.SEC_KEY_ID_1 + self.loggedInUserData.consumerNo + "!^@#" + this.SEC_KEY_ID_1 + this.consumerPwd
                        + "!^@#" + this.SEC_KEY_ID_1 + self.loggedInUserData.mobileNo;;
          // var sessionKey = AppSettings.SEC_KEY_ID_1 + "true!^@#" + AppSettings.SEC_KEY_ID_1 + "ASANSOL ENGG. COLLEGE" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "principal.aecwb@gmail.com" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "ASANSOL-DPS" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "DPS" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "3100160" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "self.loginmodel.SignInPass";
          var encrypted: any = CryptoJS.AES.encrypt(sessionKey, key, { iv: iv });
          encrypted = (encrypted).toString();
          window.sessionStorage.setItem('sessionKey', encrypted);
          this.sessionData = this.session.getSessionDetails();
          this.cd.detectChanges();
          //--------------------------//
          switch (this.parentId) {
            case 1002:
              //this.getLinkforConsumerProfile();
              this.goToConsumerProfile();
              break;
            case 1003:
              this.goToComplaintReporting();
              break;
            case 1005:
              this.viewPastBills(this.parentId);
              break;
            case 1065:
              this.getEmailId();
              break;
            case 1006:
              //this.getBillDetailsforDownload();
              this.getBillHistory();
              break;
            default:
              this.pushingAnswer("Please, try again later!");
              this.scrollToBottom();
              break;
          }

          //--------------------------//
          //this.router.navigate(['/dashboardCat'], { skipLocationChange: false });
          // self.serviceOn = false;
          //window.location.replace('');	
        } else if ((self.loggedInUserData.status === 'Failure') && !(self.loggedInUserData.registered)) {
          //self.serviceOn = false;
          self.errorMsg = "Sorry! There is some technical problem. Please try later.";
          this.cd.detectChanges();
          this.pushingAnswer(self.errorMsg);
          this.scrollToBottom();
        }

      });
  }
  //------Function for 2.Customer Profile-------//
  getLinkforConsumerProfile() {
    setTimeout(() => {
      let data = {
        id: this.parentId
      }

      this.http.getAnswer(data).subscribe((res: any) => {
        this.answercounter = 0;
        this.parentId = 0;
        res.responseList.forEach(() => {
          this.answercounter = this.answercounter + 1;
        });
        this.dataArray = [];
        this.dataArray.push(res.responseList);
        //-----for link-------------//
        for (let item of this.dataArray) {
          for (let items of item) {
            this.textboxdata = items.question
            items.counter = this.answercounter;
            items.newcolumn = "A";
            this.answerArray.push(items);
            this.IsLink = items.link;
          }
        }
      },
        (error) => {
          this.errorMsg = error;
          this.pushingAnswer(this.errorMsg);
          this.scrollToBottom();
        });
    }, 1000);
  }
  //------End of Function for 2.Customer Profile-------//
  //------Function for 3.Complaint Reporting and tracking-------//
  getLinkOfComplaintReporting() {
    setTimeout(() => {
      let data = { id: this.parentId }
      this.http.getAnswer(data).subscribe(
        (success) => {
          this.parentId = 0;
          this.responseObj = success;
        },
        (error) => {
          this.responseObj = error;
          this.errorMsg = "Sorry !! Some error occured.";
          this.pushingAnswer(this.errorMsg);
          this.scrollToBottom();
        },
        () => {
          if (this.responseObj['responseStatus'] === 0) {
            this.pushingAnswer(this.responseObj['responseMessage']);
            this.scrollToBottom();
          }
          if (this.responseObj['responseStatus'] === 1) {
            ///
            this.answercounter = 0;
            this.responseObj.responseList.forEach(() => {
              this.answercounter = this.answercounter + 1;
            });
            this.dataArray = [];
            this.dataArray.push(this.responseObj.responseList);
            //-----for link-------------//
            for (let item of this.dataArray) {
              for (let items of item) {
                this.textboxdata = items.question
                items.counter = this.answercounter;
                items.newcolumn = "A";
                this.answerArray.push(items);
                this.IsLink = items.link;
              }
            }
            this.scrollToBottom();
          }
        });
    }, 1000);
  }
  //------End of Function for 3.Complaint Reporting and tracking-------//
  onlinePaymentsURL(num: number) {
    setTimeout(() => {
      let data = {
        id: num
      }
      this.http.getAnswer(data).subscribe((res: any) => {

      });
    }, 1000);
    this.scrollToBottom();
  }
  //------------------------------//
  getEmailId() {
    setTimeout(() =>{
      this.pushingAnswer("Your email id is " + this.sessionData.sessionEmail);
    },1000);
    this.scrollToBottom();
  }
  //-------------------------//
  goToConsumerProfile() {
    // window.location.href='http://localhost:4200/#/myprofile/' ;
    /*this.router.navigate(['/nsc', {fromConsumerView:this.fromConsumerView}]);
     this.route.params.subscribe(params => {
       this.fromConsumerView = params.fromConsumerView
     });*/
    this.route.navigate(['/myprofile']);
  }
  //-------------------------//
  goToComplaintReporting() {
    this.route.navigate(['/grevience', { consumerID : this.sessionData.consumerId }], {});
  }
  //------------FOr generating Captcha------------------//
  randomString(len: any, an: any) {
    an = an && an.toLowerCase();
    let str = "", i = 0, min = an == "a" ? 10 : 0, max = an == "n" ? 10 : 62;
    for (; i++ < len;) {
      var r = Math.random() * (max - min) + min << 0;
      str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
    }
    return str;
  }
  generateCaptcha() {
    //let cap = this.randomString(3, "");
    let cap = this.makeRandom(3, "");
    this.captchaView = cap;
    
  }
  makeRandom(lengthOfCode: number, genert: string) {
    let text = "";
    let possible = "ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
      return text;
  }
  
  //------------End of generating Captcha------------------//
  goToFeedback(){
    this.route.navigate(['/feedback', {  }], {});
  }
  goToQuickpay(){
    this.route.navigate(['/quickpay', {  }], {});
  }
  newConnection() {

    this.route.navigate(['/nsc', { newConnectin: true }], {});
  }
  //-----------Get broadcast Message for chatbot----------------//
  getBroadcastData() {
    var self = this;
    var genData = [];
    self.http.getGeneralBroadCast().subscribe(
      (data) => {
        genData = data;
      },
      (error) => {
        self.errorMsg = error;
        self.generalBroadCast = [];
      },
      () => {
        for (var i = 0; i < genData.length; i++) {
          if ((!genData[i].endDate || genData[i].endDate >= self.today) && (!genData[i].startDate || genData[i].startDate <= self.today) && genData[i].status === 1) {
            self.generalBroadCast.push(genData[i].messageBody);

          }
        }
      }
    );
    if (self.sessionData.sessionStarted && self.sessionData.sessionRegion != '') {
      //var region = ((self.sessionData.sessionRegion).startsWith("GAYA"))?"GAYA":"ASANSOL";
      var regionName = ((self.sessionData.sessionRegion));
      var regData = [];
      var zoneData = [];
      self.http.getBlroRegionNameWiseBroadcastData(regionName).subscribe(
        (data) => {
          regData = data;
        },
        (error) => {
          self.errorMsg = error;
          self.regeonalBroadCast = [];
        },
        () => {
          for (var i = 0; i < regData.length; i++) {
            if ((!regData[i].endDate || regData[i].endDate >= self.today) && (!regData[i].startDate || regData[i].startDate <= self.today) && regData[i].status === 1) {
              self.regeonalBroadCast.push(regData[i].messageBody);
            }
          }
        }
      );
      self.http.getMouzaZoneWiseBroadcastData(self.sessionData.sessionRegion, self.sessionData.cosumerZone).subscribe(
        (data) => {
          zoneData = data;
        },
        (error) => {
          self.errorMsg = error;
          self.zonalBroadCast = [];
        },
        () => {
          for (var i = 0; i < zoneData.length; i++) {
            if ((!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today) && (!zoneData[i].startDate || zoneData[i].startDate <= self.today) && zoneData[i].status === 1) {
              self.zonalBroadCast.push(zoneData[i].messageBody);
            }
          }
        });
    }
  }
  //------------End of Get broadcast Message for chatbot--------------//
  //------------Viwes past 6 months Bill for chatbot--------------//
  viewPastBills(requestId) {
    this.cd.detectChanges();
    
    this.scrollToBottom();
    setTimeout(() => {
      this.route.navigate(['/bill', { consumerId: this.sessionData.consumerId }], {});
      //this.getBillHistory();
    }, 1000);

  }
  //------------End of Viwes past 6 months Bill for chatbot--------------//
  //------------ Download Bills and Receipt for chatbot--------------//
  getBillDetailsforDownload( billDate:any) {
    this.cd.detectChanges();
    let today: any = new Date();
    let todayDD: any = today.getDate();
    let todayMM: any = today.getMonth() + 1;
    //let todayMM: any = today.getMonth();

    let todayYYYY: any = today.getFullYear();
    let tillDate: any = today.setDate(today.getDate() - 30);
    let tillDateDD: any = new Date(tillDate).getDate();
    let tillDateMM: any = new Date(tillDate).getMonth() + 1;
    //let tillDateMM: any = new Date(tillDate).getMonth() ;
    let tillDateYYYY: any = new Date(tillDate).getFullYear();
    if (todayMM < 10) { todayMM = "0" + todayMM }
    if (tillDateDD < 10) { tillDateDD = "0" + tillDateDD }
    if (todayDD < 10) { todayDD = "0" + todayDD }
    if (tillDateMM < 10) { tillDateMM = "0" + tillDateMM }
    let currentDate = todayDD + "." + todayMM + "." + todayYYYY;
    let tillDates = tillDateDD + "." + tillDateMM + "." + tillDateYYYY;
    //this.consumerNoAndDate = tillDates + ',' + this.consumerID;
    this.consumerNoAndDate = billDate + ',' + this.sessionData.consumerId;
    this.spinnerload = true;
    
    this.http.createAndDownloadBillPdf(this.consumerNoAndDate).subscribe(
      (success: any) => {
      }, error => {
        this.errorMsg = "Error in Invoice Pdf file creation !";
        if (error.error.text.trim() == "Bill is yet to be generated!") {
          this.spinnerload = false;
          this.pushingAnswer(error.error.text.trim());
          this.scrollToBottom();
        }
        else if (error.error.text == "success") {
          //alert("Consumer  No with date: "+this.consumerNoAndDate)
          this.http.downloadBillDocument(this.consumerNoAndDate).subscribe(
            downloadSuccess => {
              const blob = downloadSuccess.blob();
              const file = new Blob([blob], {});
              var fileURL = URL.createObjectURL(blob);
              //this.pushingAnswer(fileURL);

              let newWindow = window.open(fileURL);
              if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
                this.getBillDetailsBlocked = true;
                setTimeout(() => { this.getBillDetailsBlocked = false; }, 3000);
              }
              this.spinnerload = false;
              //this.serviceOn = false;
            }) // end of inner subscription
        } else if (error.error.text.trim() == "failed") {
          this.spinnerload = false;
          this.pushingAnswer(this.errorMsg);
          this.scrollToBottom();
        }
      });
  }
  //------------End of Download Bills and Receipt for chatbot--------------//eturn p
  getBillHistory() {

		var self = this;
	
		self.billFetched = true;
		var today: any = new Date();
		var todayDD: any = today.getDate();
		var todayMM: any = today.getMonth() + 1;

		var todayYYYY: any = today.getFullYear();
		var tillDate: any = today.setDate(today.getDate() - 180);
		var tillDateDD: any = new Date(tillDate).getDate();
		var tillDateMM: any = new Date(tillDate).getMonth() + 1;
		var tillDateYYYY: any = new Date(tillDate).getFullYear();

		if (todayMM < 10) { todayMM = "0" + todayMM }
		if (tillDateDD < 10) { tillDateDD = "0" + tillDateDD }
		if (todayDD < 10) { todayDD = "0" + todayDD }
		if (tillDateMM < 10) { tillDateMM = "0" + tillDateMM }
		
			var requestedParams: any = self.sessionData.consumerId + "^" + todayYYYY + "-" + todayMM + "-" + todayDD + "^" + tillDateYYYY + "-" + tillDateMM + "-" + tillDateDD;//"2010265374^2018-03-31^2018-01-01"
			var requestedRegeon: any = self.sessionData.sessionRegion;
		

		if ((requestedRegeon).startsWith("GAYA")) {
			self.http.getGayaBillHistory(requestedParams)
				.subscribe(
					(data) => {
						self.allBillData = data.billParam;
					},
					(error) => {
						//self.errorMsg = error;
						self.allBillData = "";
            this.pushingAnswer(error);
            this.scrollToBottom();
            this.spinnerload = false;
					},
					() => {

						if (self.allBillData != "") {
							self.allBillData = (self.allBillData).split(" | ");
						}
						var billData = [];
						//self.barChartLabels = [];
						for (var i = 0; i < self.allBillData.length; i++) {
							//self.barChartLabels.push((self.allBillData[i]).split(" ")[1]);
							billData.push((self.allBillData[i]).split(" ")[2]);
						}
            self.allBillData.forEach((each,index) => {
              setTimeout(() => {
                this.pushingAnswer((index+1)+". "+each.split(" ")[1]+"\t\t\t\t₹"+each.split(" ")[2]);
              },1000)
              
            });
						//self.barChartData[0].data = billData;
						//self.barChartDatadoughnut = billData;
            this.scrollToBottom();
            this.spinnerload = false;
					}
				);
		} else {
			//alert("Asansol Bill History");
			self.http.getAsanBillHistory(requestedParams)
				.subscribe(
					(data) => {

						if(data.status === "NORESPONSEFROMSAP") {
							self.status = data.status;
							self.errorMsg = "Your last 6 months bill history is not available !";
							//self.serviceOn = false;
              this.pushingAnswer(self.errorMsg);
              this.scrollToBottom();
              this.spinnerload = false;
						}else{
							 self.allBillData = data.billParam;
               this.scrollToBottom();
						}
					},
					(error) => {
						//self.errorMsg = error;
						self.allBillData = "";
            this.pushingAnswer(error);
            this.scrollToBottom();
            this.spinnerload = false;
					},
					() => {

						if (self.allBillData != "") {
							self.allBillData = (self.allBillData).split(" | ");
						}
						var billData = [];
						for (var i = 0; i < self.allBillData.length; i++) {
							//self.barChartLabels.push((self.allBillData[i]).split(" ")[1]);
							billData.push((self.allBillData[i]).split(" ")[2]);
						}
						//self.barChartData[0].data = billData;
						//self.barChartDatadoughnut = billData;
            this.pushingAnswer("Please enter the Serial Number of Bill period to generate bill.");
            self.allBillData.forEach((each,index) => {
              setTimeout(() => {
                this.pushingAnswer((index+1)+". "+each.split(" ")[1]+" ---  \t\t\t\t₹"+each.split(" ")[2]);
              },1000)  
            });
            this.downloadBillCounter = 1 ;
            this.scrollToBottom();
            this.spinnerload = false;
					}   
				);
		}
	}
  //------------------forgotPassword--------------------//
  forgotPassword() {
    this.FlagDisbleConsumerCounter = 0;
    this.consumerIDFlag = false;
    this.disabledMenu = false;
    setTimeout(() => {
      this.http.forgotPassword( this.consumerID).subscribe(
        (data) => {
          this.forgotresponse = data;
        },
        (error) => {
          this.errorMsg = error;
          this.forgotresponse = "";
        },
        () => {	
          if (this.forgotresponse) {
            this.successMsg = "Please check your registered email for password reset instructions";
            this.pushingAnswer(this.successMsg );
            this.scrollToBottom();
          }					
          else {
            this.errorMsg = "We are unable to process your request.";	
            this.pushingAnswer(this.errorMsg );
            this.scrollToBottom();
          }		
        }
      ); },1000);  
  }
  //---------------End of forgotPassword------------------//
  //-----------------------------------------//
  disableForgotPasswordWhenLoggedIn() {
    setTimeout(() => {
      this.pushingAnswer("Sorry! You're already logged in.");
    },1000)  ;
    this.scrollToBottom();
  }
  //--------------------------//
  goToPaymentNsc(){  
    setTimeout(() => {
      this.route.navigate(['/paymentNsc', {  }], {});
    },1000)  ;
    this.scrollToBottom();
  }
  getGrevienceByConsumerId(consumerNumber){
		this.http.getGrevienceDetailsByConsumerNo(consumerNumber)
		.subscribe(
			(data: any) => {
				this.allGrevienceData = data;

			},
			(error) => {
				//	self.errorMsg = error;
				this.allGrevienceData = [];
			},
			() => { }
		);
	}
}
@Pipe({ name: 'chatbot.component.html'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/chatbot/chatbot.component.ts